/**
 * Customer-facing names for FeaturePlan records.
 * The create form is a Task, not a "feature request".
 *
 * Persistence, routes (`/feature-plans`), collections, analytics, and JS/TS
 * identifiers stay Work Brief / FeaturePlan / workBriefId. Do not rename those
 * without a proven migration.
 *
 * Compatibility:
 * - Codebase Guide "task type scope" is a different concept (rule matching by
 *   work type). It is not this Task entity.
 * - Test IDs such as `work-briefs-panel` and `work-brief-guided-flow` stay
 *   stable so existing selectors keep working.
 */
export const TASK_LABEL = "Task";
export const TASKS_LABEL = "Tasks";
export const TASK_DESCRIPTION_LABEL = "Task description";
export const PREPARE_TASK_FIRST = "Prepare this Task first.";
export const QUESTION_SAVE_ANSWER = "Save answer";
export const QUESTION_RECOMMEND = "Recommend an option";
export const QUESTION_NOT_SURE = "I'm not sure";
export const QUESTION_DEFER = "Defer this decision";
export const QUESTION_DOES_NOT_APPLY = "This does not apply";
export const QUESTION_REVISE = "Save revised answer";

export function taskTitleFromRequest(text, fallback = "Untitled Task") {
  const line = String(text || "")
    .trim()
    .split(/\r?\n/)[0]
    .trim();
  if (!line) return fallback;
  return line;
}
